// extracted by mini-css-extract-plugin
module.exports = {"forgot":"style_forgot__1-l1-","logo":"style_logo__1XY0m","more":"style_more__242ub","welcome":"style_welcome__3N9ms","form":"style_form__K9Axq","footer":"style_footer__1VsQ4"};